import { Form } from 'react-bootstrap';
const Select = ({ disabled = false , value, name, label, onChange, required, data }) => {
  return (
    <Form.Select className="input" disabled={disabled} value={value} name={name} onChange={onChange} required={required}>
      <option value="">Select {label}</option>
      {data.map((item) => {
        return (
          <option key={item?.id} value={item?.id}>
            {item?.name}
          </option>
        );
      })}
    </Form.Select>
  );
};

export default Select
